import _extends from "@babel/runtime/helpers/extends";
import { useBanner, BANNER_SCALING_WHEN_WINDOW_WIDTH_LOWER, usePlainCss, scaleMobile, bannerInlineStylesRightSide, bannerInlineStylesLeftSide, bannerInlineStyleBody, bannerInlineStyleBodyContainer, bannerInlineStyleBodyDescription, commonInlineStyleBodyTeaching, commonInlineStyleBodyTeachingsSeparator, BannerDottedGroupList, BannerTcfStackList, BannerGroupList, BannerTcfGroupList, BannerButtonList, BannerHistorySelect, useCommonTeachings } from "../../..";
import { useMemo, Fragment } from "react";

var BannerBody = function BannerBody(_ref) {
  var _document$getElementB;

  var leftSideContainerRef = _ref.leftSideContainerRef,
      rightSideContainerRef = _ref.rightSideContainerRef;
  var banner = useBanner();
  var type = banner.layout.type,
      mobile = banner.mobile,
      teachingsSeparatorActive = banner.bodyDesign.teachingsSeparatorActive,
      tcf = banner.tcf,
      individualPrivacyOpen = banner.individualPrivacyOpen,
      activeAction = banner.activeAction,
      pageRequestUuid4 = banner.pageRequestUuid4;

  var _useCommonTeachings = useCommonTeachings(),
      description = _useCommonTeachings.description,
      teachings = _useCommonTeachings.teachings; // Make the content responsive


  var leftSideId = "bnnr-body-leftSide-".concat(pageRequestUuid4);
  var rightSideId = "bnnr-body-rightSide-".concat(pageRequestUuid4);
  var contentId = "cntnt-".concat(pageRequestUuid4);
  usePlainCss(" #".concat(leftSideId, " img {\n  max-width: 100%;\n  height: auto;\n}\n\n").concat(((_document$getElementB = document.getElementById(pageRequestUuid4)) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.clientWidth) > BANNER_SCALING_WHEN_WINDOW_WIDTH_LOWER ? "" : "#".concat(leftSideId, " {\n    float: initial !important;\n    width: auto !important;\n    padding-right: initial !important;\n    ").concat(scaleMobile(mobile, pageRequestUuid4, type, "banner") === "banner" && !individualPrivacyOpen ? "padding-bottom: 10px !important;" : individualPrivacyOpen ? "padding-top: 10px !important;" : "", "\n    }\n\n    #").concat(contentId, " {\n        min-height: calc(var(--rendered-height-header) + var(--rendered-height-footer) + var(--rendered-height-rightSideContainer) + 60px);\n    }\n    \n    #").concat(rightSideId, " {\n    float: initial !important;\n    width: auto !important;\n    max-width: initial !important;\n    margin: initial !important;\n    ").concat(individualPrivacyOpen ? "padding-bottom: 5px !important;" : "padding-top: 10px !important;", "\n    position: sticky;\n    }"))); // Calculate the body content depending on TCF availability and if second view got opened

  var stackOrGroups = useMemo(function () {
    if (process.env.IS_TCF === "1" && tcf) {
      return individualPrivacyOpen ? h(BannerTcfGroupList, null) : h(BannerTcfStackList, null);
    } else {
      return individualPrivacyOpen ? h(BannerGroupList, null) : h(BannerDottedGroupList, null);
    }
  }, [individualPrivacyOpen, tcf]);
  var leftSide = h("div", _extends({
    ref: leftSideContainerRef,
    key: "leftSide",
    id: leftSideId
  }, bannerInlineStylesLeftSide(banner)), h("div", bannerInlineStyleBodyDescription(banner), activeAction === "history" ? h(BannerHistorySelect, null) : h(Fragment, null, h("span", {
    dangerouslySetInnerHTML: {
      __html: description
    }
  }), teachings.length > 0 && h(Fragment, null, teachingsSeparatorActive && h("div", null, h("span", commonInlineStyleBodyTeachingsSeparator(banner))), teachings.map(function (teaching) {
    return h("span", _extends({
      key: teaching
    }, commonInlineStyleBodyTeaching(banner), {
      dangerouslySetInnerHTML: {
        __html: teaching
      }
    }));
  })))), stackOrGroups);
  var rightSide = activeAction === "history" ? h("div", {
    ref: rightSideContainerRef
  }) : h("div", _extends({
    ref: rightSideContainerRef,
    key: "rightSide",
    id: rightSideId
  }, bannerInlineStylesRightSide(banner)), h(BannerButtonList, null));
  return h("div", bannerInlineStyleBodyContainer(banner), h("div", bannerInlineStyleBody(banner), individualPrivacyOpen ? [rightSide, leftSide] : [leftSide, rightSide], h("div", {
    style: {
      clear: "both"
    }
  })));
};

export { BannerBody };